import React, { useState, useContext } from "react";
import "./ResetPasswordPage.css";
import { MyContext } from "../../../../Context/MyContext";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ResetPasswordPage = ({ setActiveView }) => {
  const { logininput } = useContext(MyContext);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    new_password: "",
    confirm_password: "",
  });

  const [showPass, setShowPass] = useState(false);
  const [showCPass, setShowCPass] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const handleSubmit = (e) => {
  e.preventDefault();

  for (let item of logininput.reset_password) {
    if (item.isrequired && !formData[item.field]) {
      toast.error(`${item.name} is required!`);
      return;
    }
  }

  if (formData.new_password !== formData.confirm_password) {
    toast.error("Password and Confirm Password must match!");
    return;
  }

  toast.success("Password Reset Successful!");

  // ✅ move back ONLY after success
  setActiveView("content");
};

  return (
    <div className="resetpage-container">

        <button
  className="reset-back-btn"
  onClick={() => setActiveView("content")}
>
  ← Back
</button>

      <div className="resetpage-box">

        <h2>Reset Password</h2>
        <p>Enter your new password</p>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>New Password</label>
            <div className="input-wrapper">
              <input
                type={showPass ? "text" : "password"}
                name="new_password"
                value={formData.new_password}
                onChange={handleChange}
                placeholder="Enter new password"
              />
              <span className="eye-icon" onClick={() => setShowPass(!showPass)}>
                {showPass ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>

          <div className="input-group">
            <label>Confirm Password</label>
            <div className="input-wrapper">
              <input
                type={showCPass ? "text" : "password"}
                name="confirm_password"
                value={formData.confirm_password}
                onChange={handleChange}
                placeholder="Confirm password"
              />
              <span className="eye-icon" onClick={() => setShowCPass(!showCPass)}>
                {showCPass ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>

         <button className="reset-btn" type="submit">
  Reset Password
</button>

        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;